import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import OrderFare from '../../records/order/Fare';

import Icon from '../general/Icon';
import FareValidity from '../fares/FareValidity';


function SeasonFareShort ({ orderFare }) {
    return (
        <li className="order-summary__item season-fare-short order-summary__item--short margin-bottom">
            <Row className="fare-summary">
                <Col xs={ 12 } md={ 6 } lg={ 6 }>
                    <div className="like-table">
                        <div className="table-row">
                            <div className="table-cell text-weight--normal">{ orderFare.origin.name }</div>
                            <div className="table-cell direction text-center"><Icon icon="switch" className="otrl-rotate-90" /></div>
                            <div className="table-cell text-weight--normal">{ orderFare.destination.name }</div>
                        </div>
                    </div>
                </Col>

                <Col xs={ 12 } md={ 6 } lg={ 6 } className="text-weight--normal ticket-type no-margin">
                    <p className="text-weight--normal ticket-type no-margin">
                        { orderFare.getName() }
                    </p>
                </Col>
            </Row>

            <FareValidity
                from={ orderFare.outwardJourney.validFrom }
                to={ orderFare.outwardJourney.validTo }
            />
        </li>
    );
}


SeasonFareShort.propTypes = {
    orderFare: PropTypes.instanceOf(OrderFare).isRequired,
    open: PropTypes.bool
};

SeasonFareShort.defaultProps = {
    open: false
};


export default SeasonFareShort;
